/**
 * Dictionnaire FR — source de vérité des clés i18n (Phase 8C).
 *
 * Split par langue : le FR (et l'EN) restent dans le bundle principal ;
 * les 5 langues secondaires (`es/de/pt/it/pl`) vivent dans leurs
 * propres modules et sont chargées à la demande via `import()`
 * (cf. `../strings.ts`). Aucune traduction n'a été modifiée au split.
 */
export const fr = {
  home: 'Accueil',
  messages: 'Messages',
  planning: 'Planning',
  tasks: 'Tâches',
  photos: 'Photos',
  meals: 'Repas',
  settings: 'Réglages',
  foyer_tab: 'Foyer',
  this_week: 'Cette semaine',
  planning_du_au_join: 'au',
  planning_week_label: 'Semaine',
  planning_prev_week: 'Semaine précédente',
  planning_next_week: 'Semaine suivante',
  planning_from_word: 'Du',
  planning_hero_title: 'La semaine',
  messages_hero_accent: 'de la famille',
  cp_home_hero_title: 'La semaine',
  cp_home_hero_accent_fallback: 'partagée',
  cp_home_hero_accent_child: 'de {name}',
  meals_hero_title: 'À table,',
  meals_hero_accent: 'cette semaine',
  meals_kpi_planned: 'Planifiés',
  meals_kpi_courses: 'Courses',
  meals_kpi_to_plan: 'À planifier',
  meals_kpi_courses_delta: 'articles',
  meals_kpi_to_plan_delta: 'jours restants',
  photos_hero_title: 'L’album',
  photos_hero_accent: 'de la famille',
  photos_hero_dateline: 'Souvenirs récents',
  messages_hero_title: 'Le fil',
  messages_hero_dateline: 'En famille',
  settings_hero_title: 'Votre',
  settings_hero_accent: 'foyer',
  settings_hero_title_cp: 'Vos',
  settings_hero_accent_cp: 'réglages',
  cp_home_dateline: 'Garde alternée',
  cp_act_hero_title: 'Deux',
  cp_act_hero_accent: 'semaines',
  cp_act_dateline: 'Calendrier de garde',
  cp_lia_hero_title: 'Le livre',
  cp_lia_hero_accent: 'de liaison',
  cp_frais_hero_title: 'Les comptes',
  cp_frais_hero_accent: 'du mois',
  cp_frais_dateline: 'Solde du mois',
  cp_bag_hero_title: 'Le sac',
  cp_bag_hero_accent: 'à dos',
  cp_bag_dateline: 'Avant la transition',
  cp_school_hero_title: 'Vie',
  cp_school_hero_accent: 'scolaire',
  cp_school_dateline: 'Notes & devoirs',
  cp_settings_dateline: 'Garde & règles',
  onb_step_label: 'Étape',
  sw_update_available: 'Une nouvelle version de Nestor vous attend — on rafraîchit ?',
  sw_update_reload: 'Recharger',
  sw_update_later: 'Plus tard',
  mutations_queued: 'Action enregistrée — on synchronisera dès la reconnexion.',
  mutations_synced: 'Tout est à jour côté serveur.',
  mutations_pending_badge: 'En attente',
  invite_section_title: 'Inviter un coparent',
  invite_section_sub: 'Envoyez un email pour partager ce foyer.',
  invite_button: 'Inviter',
  invite_modal_title: 'Inviter à rejoindre le foyer',
  invite_email_label: 'Adresse email',
  invite_email_placeholder: 'eve@example.com',
  invite_role_label: 'Rôle',
  invite_role_parent: 'Parent',
  invite_role_teen: 'Ado',
  invite_role_child: 'Enfant',
  invite_submit: 'Envoyer l’invitation',
  invite_sent_toast: 'Invitation envoyée.',
  invite_accept_loading: 'On prépare votre invitation…',
  invite_accept_title: 'Rejoindre',
  invite_accept_invited_by: 'Invité·e par',
  invite_accept_role_label: 'Rôle proposé',
  invite_accept_expires_at: 'Expire le',
  invite_accept_button: 'Accepter et rejoindre',
  invite_accept_signin_first: 'Connectez-vous pour accepter.',
  invite_accept_signed_in_as: 'Connecté·e en tant que',
  invite_accepted_toast: 'Bienvenue dans le foyer.',
  invite_error_expired: 'Cette invitation est expirée ou inconnue.',
  invite_error_already: 'Cette invitation a déjà été acceptée.',
  invite_error_mismatch: 'Cette invitation est pour un autre email.',
  invite_error_offline: 'Service indisponible — réessayez quand vous êtes en ligne.',
  account_section: 'Mon compte',
  account_anonymous_title: 'Vous utilisez Nestor en mode local.',
  account_anonymous_sub: 'Créez un compte pour retrouver vos foyers depuis tous vos appareils.',
  account_btn_login: 'Se connecter',
  account_btn_register: 'Créer un compte',
  account_btn_logout: 'Se déconnecter',
  account_offline: 'Service hors ligne — vous pourrez vous connecter dès que possible.',
  account_signed_in_as: 'Connecté en tant que',
  account_email_label: 'Adresse email',
  account_password_label: 'Mot de passe',
  account_name_label: 'Votre prénom',
  account_lang_label: 'Langue préférée',
  account_password_hint: 'Au moins 8 caractères.',
  account_modal_login: 'Connexion',
  account_modal_register: 'Création de compte',
  account_btn_submit_login: 'Se connecter',
  account_btn_submit_register: 'Créer mon compte',
  account_err_invalid_email: "L'email n'a pas l'air valide.",
  account_err_password_too_short: 'Le mot de passe doit faire au moins 8 caractères.',
  account_err_name_required: 'Indiquez un prénom à afficher.',
  account_err_invalid_credentials: 'Email ou mot de passe incorrect.',
  account_err_email_taken: 'Cet email est déjà utilisé. Essayez de vous connecter.',
  account_err_network: 'Impossible de joindre Nestor. Réessayez dans un instant.',
  account_err_generic: 'Une erreur est survenue. Réessayez dans un instant.',
  home_planning_merged: 'Planning fusionné',
  home_meals_planned: 'Repas planifiés',
  home_entry_one: 'entrée',
  home_entry_other: 'entrées',
  home_view_all: 'voir tout',
  home_kpi_today: "Aujourd'hui",
  home_kpi_meals: 'Repas',
  home_kpi_photos: 'Photos',
  home_kpi_meals_delta: 'planifiés',
  home_kpi_photos_delta: 'cette semaine',
  home_family: 'famille',
  home_section_today_sub: 'Planning fusionné',
  home_section_members_sub: 'La journée de chacun',
  home_section_week_sub: 'Repas planifiés',
  home_box_family_event: 'Événement familial',
  home_box_meals_today: 'Repas du jour',
  home_box_last_messages: 'Derniers messages',
  home_no_family_event: 'Rien de programmé',
  home_meal_lunch: 'Midi',
  home_meal_dinner: 'Soir',
  home_meals_to_plan: 'À planifier',
  home_no_messages: 'Aucun message',
  home_no_members_hint: 'Ajoutez des membres dans Réglages pour voir leur journée ici.',
  weather_enable: 'Activer la météo',
  weather_denied: 'On réessaie la météo ?',
  weather_loading: 'Météo…',
  weather_refresh: 'Actualiser',
  weather_cond_clear: 'Ensoleillé',
  weather_cond_partly: 'Peu nuageux',
  weather_cond_cloudy: 'Nuageux',
  weather_cond_fog: 'Brouillard',
  weather_cond_drizzle: 'Bruine',
  weather_cond_rain: 'Pluie',
  weather_cond_snow: 'Neige',
  weather_cond_thunder: 'Orage',
  tag_event_label: 'Rendez-vous',
  tag_task_label: 'Tâche',
  tag_meal_label: 'Repas',
  hello: 'Bonjour',
  today: "Aujourd'hui",
  pending: 'restantes',
  done: 'Terminées',
  save: 'Sauvegarder',
  recipes: 'Recettes',
  search: 'Rechercher…',
  family: 'Famille',
  members: 'Membres',
  modal_add_home_title: 'Nouveau foyer',
  modal_add_member_title: 'Nouveau membre',
  role_help_label: "Comprendre les niveaux d'accès",
  version: 'Version',
  weather: 'Météo',
  access: "Niveaux d'accès",
  account: 'Mon compte',
  preferences: 'Préférences',
  grocery: 'Liste de courses',
  servings: 'Nombre de portions',
  week: 'Semaine en cours',
  new_meal: 'Nouveau repas',
  history: 'Historique',
  add: 'Ajouter',
  view: 'Voir',
  hide: 'Masquer',
  logout: 'Déconnexion',
  invite: '+ Inviter un membre',
  send: 'Envoyer',
  record: 'Enregistrer',
  login: 'Connexion',
  notifs: 'Notifications push',
  pw_change: 'Modifier mon mot de passe',
  family_name: 'Nom de famille',
  from_recipes: 'Depuis les recettes',
  manual: 'Ajoutés manuellement',
  connected: 'Connecté ✓',
  connect: 'Connecter',
  lang_setting: 'Langue',
  lang_change: 'Changer la langue',
  cp_home: 'Accueil',
  cp_journal: 'Journal',
  cp_activities: 'Activités',
  cp_school: 'Scolarité',
  cp_bag: 'Sac à dos',
  cp_liaison: 'Liaison',
  cp_frais: 'Frais',
  cp_settings: 'Réglages',
  add_home: '+ Ajouter un foyer',
  messages_local_hint: 'Messages locaux à cet appareil — créez un compte pour synchroniser.',
  messages_sender_label: 'Qui écrit ?',
  home_type_label: 'Type de foyer',
  home_type_classic: 'Classique',
  home_type_coparenting: 'Co-parentage',
  my_homes: 'Mes foyers',
  active: 'Actif',
  switch_home: 'Changer de foyer',
  journal_info: "Journal — fil d'information factuel, pas de chat.",
  custody: 'Garde',
  parent_a: 'Parent A',
  parent_b: 'Parent B',
  bag_complete: 'Sac complet',
  item_ok: 'Présent',
  item_missing: 'Manquant',
  transfer: 'Transféré',
  ai_suggests: 'Nestor suggère',
  handover: 'Passation',
  score_great: 'Tout est bien organisé',
  score_ok: 'Bonne organisation globale',
  score_low: 'Quelques éléments à préparer',
  weekly_at: 'Semaine avec',
  today_with: 'Avec',
  work_email: 'Email professionnel',
  sync_cal_btn: 'Synchroniser les calendriers',
  legal: 'Informations légales',
  privacy: 'Politique de confidentialité',
  terms: "Conditions d'utilisation",
  rules: 'Règlement du programme',
  lunch: 'Déjeuner',
  dinner: 'Dîner',
  attach_file: 'Joindre un fichier',
  planning_merged: 'Planning',
  // Phase 1, incrément 5 — port de vSettings : libellés inline du proto
  // qui n'étaient pas dans TR (proto l. 1914-1916, 1902, 1907, 1947,
  // 1960, 1962). Ajoutés ici pour passer le check anti-leaks.
  role_parent: 'Parent',
  role_teen: 'Ado',
  role_child: 'Enfant',
  role_parent_desc: 'Accès complet — créer, modifier, supprimer',
  role_teen_desc: 'Ajouter du contenu',
  role_child_desc: 'Lecture seule — cocher ses tâches',
  role_hint_icon_label: "Voir le niveau d'accès",
  member_affect_legend: 'Affecter à',
  affect_principal: 'Principal',
  affect_coparental: 'Co-parental',
  affect_both: 'Les deux',
  member_pending: 'Invitation envoyée',
  member_remove: 'Retirer',
  member_remove_title: 'Retirer ce membre',
  member_last_parent_hint:
    'Un foyer garde toujours au moins un parent — ajoutez un autre parent avant de retirer celui-ci.',
  member_edit: 'Modifier',
  data_export: 'Exporter données',
  account_delete: 'Supprimer compte',
  lang_apply_info: "La langue s'applique à tout le dispositif.",
  home_rename: 'Renommer le foyer',
  home_remove: 'Supprimer ce foyer',
  remove: 'Supprimer',
  rename: 'Renommer',
  // Placeholder pour les écrans pas encore livrés (RGPD, mot de passe…)
  coming_soon: 'Bientôt disponible',
  // Phase 1, incrément 6 — vHome (port l. 1661+)
  upcoming: 'À venir',
  nothing_planned: 'Rien de prévu',
  tonight: 'Ce soir',
  add_photo: 'Ajouter une photo',
  no_homes_yet: "Aucun foyer configuré pour l'instant.",
  go_to_settings: 'Aller dans Réglages',
  // Phase 1, incrément 7 — vPlanning (port l. 1740+) + vTasks (l. 1788+)
  add_event: '+ Événement',
  add_task: '+ Tâche',
  add_task_full: '+ Ajouter une tâche',
  to_do: 'À faire',
  no_pending_tasks: 'Aucune tâche en attente !',
  event_title: 'Titre',
  event_date: 'Date',
  event_time: 'Heure',
  event_location: 'Lieu',
  task_text: 'Tâche',
  task_due: 'Échéance',
  who: 'Qui',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  close: 'Fermer',
  unassigned: 'Non assigné',
  // Initiales jours semaine (proto l. 1747 : D L M Me J V S, dimanche premier)
  weekday_sun: 'D',
  weekday_mon: 'L',
  weekday_tue: 'M',
  weekday_wed: 'Me',
  weekday_thu: 'J',
  weekday_fri: 'V',
  weekday_sat: 'S',
  // Phase 1, incrément 8 — vMessages (port l. 1723+).
  // `send` existe déjà plus haut dans le dictionnaire (TR du proto).
  msg_placeholder: 'Message…',
  start_conversation: 'Démarrez la conversation',
  voice_message: 'Message vocal',
  mic_denied: 'Microphone non autorisé',
  me: 'moi',
  voice_recording: 'Enregistrement…',
  stop_recording: 'Arrêter',
  voice_pause: 'Pause',
  voice_seek: 'Position de lecture',
  voice_rate: 'Vitesse de lecture',
  voice_hold_hint: 'Maintenir pour enregistrer',
  voice_slide_cancel: '← Glisser pour annuler',
  voice_release_cancel: 'Relâcher pour annuler',
  attach_image: 'Joindre une image',
  no_member_yet: 'Ajoutez un membre dans Réglages pour démarrer la conversation.',
  from_label: 'De',
  delete_message: 'Supprimer ce message',
  // Phase 1, incrément 9 — vPhotos (port l. 1799+)
  all_photos: 'Toutes les photos',
  no_photos: 'Aucune photo',
  no_photos_sub: 'Partagez vos premiers souvenirs de famille.',
  albums: 'Albums',
  no_albums_sub: 'Les albums apparaîtront ici lorsque vous ajouterez des photos.',
  auto_album: 'Classer par date',
  auto_album_done: 'Photos classées par mois de prise de vue.',
  share: 'Partager',
  share_album: 'Partager cet album',
  share_copied: 'Lien copié dans le presse-papier.',
  share_unsupported: "Le partage natif n'est pas disponible sur ce navigateur.",
  caption_label: 'Légende',
  album_label: 'Album',
  album_optional: '(optionnel)',
  no_album: 'Sans album',
  photo_count_one: 'photo',
  photo_count_other: 'photos',
  // Phase 1, incrément 10 — vMeals (port l. 1825+)
  plan_meals: '+ Planifier les repas',
  generate_menu_week: 'Générer le menu de la semaine',
  generation_error: 'Erreur de génération',
  weekly_menu_generated: 'Menu de la semaine généré !',
  pick_recipe: 'Choisir une recette',
  meal_name_label: 'Nom du repas',
  tag_label: 'Étiquette',
  ingredients_label: 'Ingrédients',
  service_lunch: 'Midi',
  service_dinner: 'Soir',
  meal_empty_dash: '—',
  add_item: 'Ajouter un article…',
  grocery_will_generate: 'La liste sera générée depuis vos repas planifiés.',
  grocery_checked_count: 'cochés',
  grocery_auto_short: 'auto',
  grocery_share: 'Partager la liste',
  grocery_manual_one: 'manuel',
  grocery_manual_other: 'manuels',
  quick_suggestions: 'Suggestions rapides',
  breakfast: 'Petit-déjeuner',
  snack: 'Goûter',
  clear_meal_slot: 'Vider ce service',
  // AI engine — suggestions templates (incrément 11). Ton bienveillant
  // obligatoire (CLAUDE.md §2.1). Placeholders entre accolades : {items},
  // {activity}, {item}, {count}.
  ai_bag_missing_one: 'Un petit rappel : {items} semble manquant dans le sac',
  ai_bag_missing_many: 'Un petit rappel : {items} semblent manquants dans le sac',
  ai_sport_prep:
    'Activité sport demain ({activity}) — une bonne occasion de vérifier le sac de sport',
  ai_medical_prep:
    'Rappel : {activity} est prévu demain. Pensez à vérifier les documents nécessaires.',
  ai_recurring_miss: "{item} est souvent oublié — l'ajouter en priorité dans le sac ?",
  ai_high_stress:
    "Plusieurs choses à gérer en même temps — pas de panique, l'essentiel est bien là",
  ai_score_excellent: 'Tout est bien organisé pour les prochains jours',
  ai_score_good: 'Bonne organisation globale, quelques points à vérifier',
  ai_score_low: 'Quelques éléments à préparer — tout va bien se passer',
  ai_summary_activities_one: '1 activité planifiée',
  ai_summary_activities_many: '{count} activités planifiées',
  ai_summary_journal_one: '1 entrée dans le journal',
  ai_summary_journal_many: '{count} entrées dans le journal',
  ai_summary_organized: 'Bonne organisation globale',
  ai_summary_to_follow: 'Quelques points à suivre',
  // Switch foyer — header picker (incrément 12)
  switch_home_title: 'Basculer de foyer',
  switch_home_active: 'Foyer actif',
  switch_home_other: 'Autres foyers',
  switch_home_none_other: 'Aucun autre foyer — créez-en un dans Réglages.',
  // Co-parentage Home (incrément 13) — port direct des inline FR du proto
  cp_home_greeting: 'Bonjour',
  cp_home_with: 'Avec',
  cp_home_today_activities: 'Activités du jour',
  cp_home_no_activities: 'Aucune activité ce jour',
  cp_home_recent_journal: 'Journal récent',
  cp_home_no_journal: 'Aucune entrée récente',
  cp_home_view_journal: 'Voir le journal →',
  cp_home_bag_title: 'Sac à dos',
  cp_home_bag_missing_one: 'manquant',
  cp_home_bag_missing_other: 'manquants',
  cp_home_bag_complete: 'Complet',
  cp_home_manage_bag: 'Gérer le sac →',
  cp_home_ai_suggests: 'Nestor suggère',
  cp_home_no_custody: 'Configure la garde dans les Réglages.',
  // Co-parentage Activités & Garde (incrément 14)
  cp_act_section_title: 'Activités & Garde',
  cp_act_calendar_title: 'Calendrier de garde',
  cp_act_next_2_weeks: '2 prochaines semaines',
  cp_act_upcoming: 'Activités à venir',
  cp_act_add_short: '+ Ajouter',
  cp_act_add_long: '+ Ajouter une activité',
  cp_act_none_planned: 'Aucune activité planifiée',
  cp_act_modal_title: 'Nouvelle activité',
  cp_act_label_title: 'Titre',
  cp_act_placeholder_title: 'Judo, Médecin…',
  cp_act_label_date: 'Date',
  cp_act_label_time: 'Heure',
  cp_act_label_type: 'Type',
  cp_act_label_location: 'Lieu',
  cp_act_placeholder_location: 'Lieu…',
  cp_act_label_parent: 'Parent responsable',
  cp_act_type_school: 'Scolaire',
  cp_act_type_medical: 'Médical',
  cp_act_type_sport: 'Sport',
  cp_act_type_other: 'Autre',
  cp_act_btn_add: 'Ajouter',
  cp_act_remove: 'Supprimer',
  // Co-parentage Liaison + Journal (incrément 15)
  cp_lia_section_title: 'Livre de liaison',
  cp_lia_intro: 'Transmissions officielles entre parents — horodatées et signables.',
  cp_lia_tab_transmissions: 'Transmissions',
  cp_lia_tab_demandes: 'Demandes',
  cp_lia_tab_journal: 'Journal',
  cp_lia_btn_new_transmission: '+ Transmission',
  cp_lia_btn_new_demande: 'Demande',
  cp_lia_btn_new_journal: '+ Nouvelle entrée',
  cp_lia_modal_transmission_title: 'Nouvelle transmission',
  cp_lia_modal_demande_title: 'Nouvelle demande',
  cp_lia_modal_journal_title: 'Nouvelle entrée du journal',
  cp_lia_label_text: 'Contenu',
  cp_lia_placeholder_transmission: "Ce qu'il faut transmettre…",
  cp_lia_placeholder_demande: 'Ce que vous demandez…',
  cp_lia_placeholder_journal: 'Notez ici une info importante…',
  cp_lia_signature_requested: 'Demander une signature des deux parents',
  cp_lia_btn_send: 'Envoyer',
  cp_lia_btn_add: 'Ajouter',
  cp_lia_status_brouillon: 'Brouillon',
  cp_lia_status_envoye: 'Envoyé',
  cp_lia_status_signed_a: 'Signé A',
  cp_lia_status_signed_b: 'Signé B',
  cp_lia_status_signed_both: 'Signé par les deux',
  cp_lia_status_pending: 'En attente',
  cp_lia_status_accepted: 'Acceptée',
  cp_lia_status_refused: 'Refusée',
  cp_lia_sign_a: 'Signer ({parent})',
  cp_lia_sign_b: 'Signer ({parent})',
  cp_lia_accept: '✓ Accepter',
  cp_lia_refuse: '✗ Refuser',
  cp_lia_empty_transmissions: 'Aucune transmission. Créez-en une pour formaliser une info.',
  cp_lia_empty_demandes: 'Aucune demande pour le moment.',
  cp_lia_empty_journal: 'Journal vide. Notez ici une info santé, humeur ou événement.',
  cp_lia_journal_intro: " Le journal est un fil d'information factuel. Pas de chat.",
  // Co-parentage Frais partagés (incrément 16)
  cp_frais_section_title: 'Frais partagés',
  cp_frais_balance_total: 'Total',
  cp_frais_balanced: 'Équilibré',
  cp_frais_owes_template: '{from} doit {amount} à {to}',
  cp_frais_btn_add: '+ Ajouter une dépense',
  cp_frais_modal_title: 'Nouvelle dépense',
  cp_frais_label_description: 'Description',
  cp_frais_placeholder_description: 'Ex : pharmacie, fournitures…',
  cp_frais_label_amount: 'Montant (€)',
  cp_frais_label_date: 'Date',
  cp_frais_label_category: 'Catégorie',
  cp_frais_label_paidby: 'Payé par',
  cp_frais_cat_sante: 'Santé',
  cp_frais_cat_education: 'Éducation',
  cp_frais_cat_vetements: 'Vêtements',
  cp_frais_cat_loisirs: 'Loisirs',
  cp_frais_cat_transport: 'Transport',
  cp_frais_cat_autre: 'Autre',
  cp_frais_empty: 'Aucun frais enregistré',
  cp_frais_remove: 'Supprimer',
  // Co-parentage Sac à dos (incrément 17)
  cp_bag_section_title: 'Sac à dos virtuel',
  cp_bag_status_ok: 'Sac complet ✓',
  cp_bag_status_missing_one: '{count} objet manquant',
  cp_bag_status_missing_other: '{count} objets manquants',
  cp_bag_summary_template: '{ok}/{total} objets présents · Chez {parent}',
  cp_bag_ai_sport_tomorrow: 'Activité sport demain — pensez à vérifier les affaires de sport !',
  cp_bag_card_missing_title: 'Manquants',
  cp_bag_card_present_title: 'Présents',
  cp_bag_btn_transfer: 'Transféré',
  cp_bag_btn_add: '+ Ajouter un objet',
  cp_bag_empty: 'Aucun objet dans le sac',
  cp_bag_modal_title: 'Ajouter un objet',
  cp_bag_label_item: "Nom de l'objet",
  cp_bag_placeholder_item: 'Doudou, cahier, médicament…',
  cp_bag_label_icon: 'Icône',
  cp_bag_label_category: 'Catégorie',
  cp_bag_label_location: 'Localisation actuelle',
  cp_bag_loc_at: 'Chez',
  cp_bag_loc_home: 'Maison',
  cp_bag_cat_essentiel: 'Essentiel',
  cp_bag_cat_sport: 'Sport',
  cp_bag_cat_ecole: 'École',
  cp_bag_cat_medical: 'Médical',
  cp_bag_cat_autre: 'Autre',
  cp_bag_remove: 'Supprimer',
  // Co-parentage Scolarité (incrément 18)
  cp_school_section_title: 'Scolarité',
  cp_school_btn_add: '+ Ajouter une entrée',
  cp_school_empty_title: 'Aucune donnée scolaire',
  cp_school_empty_sub: 'Ajoutez notes, devoirs et infos du prof.',
  cp_school_modal_title: 'Nouvelle entrée scolaire',
  cp_school_label_subject: 'Matière',
  cp_school_placeholder_subject: 'Maths, Français…',
  cp_school_label_type: 'Type',
  cp_school_label_value: 'Valeur',
  cp_school_placeholder_value: '15/20',
  cp_school_label_teacher: 'Enseignant',
  cp_school_placeholder_teacher: 'M. Dupont…',
  cp_school_label_comment: 'Commentaire',
  cp_school_placeholder_comment: 'Remarque…',
  cp_school_btn_submit: 'Ajouter',
  cp_school_remove: 'Supprimer',
  cp_school_type_note: 'Note',
  cp_school_type_devoir: 'Devoir',
  cp_school_type_info: 'Info',
  // Co-parentage Réglages (incrément 18) — custody config
  cp_settings_section_title: 'Réglages co-parentage',
  cp_settings_custody_title: 'Configuration de garde',
  cp_settings_label_parentA: 'Parent A',
  cp_settings_label_parentB: 'Parent B',
  cp_settings_label_startdate: 'Début alternance',
  cp_settings_label_parity: 'Semaine de départ',
  cp_settings_parity_a: 'Chez Parent A',
  cp_settings_parity_b: 'Chez Parent B',
  cp_settings_btn_save: 'Enregistrer',
  cp_settings_saved: '✓ Enregistré',
  cp_settings_view_school: 'Voir la scolarité',
  // Onboarding (incrément 19) — 2 étapes
  onb_tagline: 'Le tableau de bord de votre famille',
  login_title: 'Bon retour !',
  login_sub: 'Connectez-vous pour retrouver votre foyer sur cet appareil.',
  login_no_account: 'Pas encore de foyer ? Créer un compte',
  onb_have_account: 'Vous avez déjà un compte ? Se connecter',
  onb_step1_title: 'Bienvenue !',
  onb_step1_sub: 'Créez votre espace famille en quelques secondes.',
  onb_label_family: 'Nom de famille',
  onb_placeholder_family: 'Ex : Martin, Dupont…',
  onb_error_family: 'Veuillez saisir un nom',
  onb_btn_continue: 'Continuer →',
  onb_step2_title: 'Votre compte administrateur',
  onb_step2_sub:
    'En tant que premier Parent, vous pourrez inviter les autres membres de votre famille.',
  onb_label_name: 'Votre prénom',
  onb_placeholder_name: 'Prénom…',
  onb_error_name: 'Veuillez saisir votre prénom',
  onb_auth_placeholder: 'Email + mot de passe : à venir Phase 4 (auth réelle).',
  onb_btn_create: 'Créer mon espace famille',
  onb_btn_back: '← Retour',
  onb_offline_local:
    'Espace créé sur cet appareil. Vous pourrez finaliser votre compte en ligne depuis Réglages dès que la connexion sera disponible.',
  gdpr_export_done: 'Export téléchargé — vos données vous appartiennent.',
  gdpr_delete_confirm:
    'Supprimer toutes les données Nestor de cet appareil ?\n\nFoyers, plannings, messages, photos et vocaux locaux seront définitivement effacés. (Le compte serveur, si vous en avez un, n’est pas encore supprimé par cette action.)',
  gdpr_delete_confirm_auth:
    'Supprimer votre compte Nestor ET toutes les données de cet appareil ?\n\nVotre compte serveur, vos foyers dont vous êtes le seul membre, et toutes les données locales seront définitivement effacés. Cette action est irréversible.',
  error_boot_title: 'Oups, quelque chose s’est emmêlé. Vos données sont en sécurité.',
  error_boot_reload: 'Recharger',
  recipe_search_placeholder: 'Rechercher une recette (nom, ingrédient…)',
  recipe_search_hint: 'Recherchez parmi 8 872 recettes, ou choisissez une suggestion :',
  recipe_db_loading: 'Chargement de la base de recettes…',
  recipe_no_result: 'Aucune recette trouvée — essayez un autre mot.',
  recipe_view_sheet: 'Voir la fiche recette',
  recipe_back: '← Retour',
  recipe_use: 'Utiliser cette recette',
  recipe_steps: 'Étapes',
  recipe_servings: 'portions',
  nut_calories: 'kcal',
  nut_proteins: 'protéines',
  nut_carbs: 'glucides',
  nut_fat: 'lipides',
  nut_fiber: 'fibres',
  legal_draft_notice: 'Document provisoire (version alpha).',
  legal_version_line: 'Version alpha — juillet 2026',
  legal_terms_s1_title: '1. Objet',
  legal_terms_s1_body:
    "Nestor est une application d'organisation familiale : planning partagé, tâches, messages, photos, repas, ainsi qu'un mode co-parentage (calendrier de garde, livre de liaison, frais partagés, sac à dos).\n\nLes présentes conditions encadrent l'utilisation de Nestor pendant sa phase alpha. En utilisant l'application, vous les acceptez.",
  legal_terms_s2_title: '2. Version alpha',
  legal_terms_s2_body:
    "Nestor est en cours de développement. Des fonctions peuvent changer, être retirées ou présenter des défauts. Le service est fourni « en l'état », sans garantie de disponibilité ni d'absence d'erreur. Pensez à exporter régulièrement vos données (Réglages → Exporter données).",
  legal_terms_s3_title: '3. Comptes et rôles',
  legal_terms_s3_body:
    "Nestor fonctionne sans compte, en mode local : vos données restent alors sur votre appareil. La création d'un compte (facultative) active la synchronisation multi-appareils.\n\nTrois rôles existent dans un foyer : Parent (administre tout), Ado (ajoute du contenu) et Enfant (consulte et coche ses propres tâches). Les comptes sont créés et gérés par un parent. En mode co-parentage, les enfants n'ont pas de compte.",
  legal_terms_s4_title: '4. Vos contenus',
  legal_terms_s4_body:
    'Les contenus que vous ajoutez (photos, messages, événements…) restent votre propriété. Si vous créez un compte, vous nous autorisez uniquement à les héberger et à les transmettre aux membres de votre foyer — le strict nécessaire au fonctionnement du service.',
  legal_terms_s5_title: '5. Usage acceptable',
  legal_terms_s5_body:
    "Nestor est destiné à un usage familial et personnel. Vous vous engagez à ne pas y publier de contenu illicite et à ne pas perturber le service. En cas d'abus manifeste, l'accès au service peut être suspendu.",
  legal_terms_s6_title: '6. Évolution et contact',
  legal_terms_s6_body:
    "Ces conditions évolueront avec le produit (bêta, lancement public). En cas de changement notable, une information s'affichera dans l'application. Pour toute question, utilisez le canal de contact communiqué lors de votre invitation au programme alpha.",
  legal_privacy_s1_title: '1. Notre approche',
  legal_privacy_s1_body:
    "Nestor est conçu « local d'abord » : par défaut, vos données sont stockées uniquement sur votre appareil. Sans compte, rien ne quitte votre appareil.\n\nNous ne vendons aucune donnée et n'affichons aucune publicité.",
  legal_privacy_s2_title: '2. Données sur votre appareil',
  legal_privacy_s2_body:
    "Foyers, membres, plannings, tâches, messages, photos, repas et préférences sont enregistrés localement (localStorage et IndexedDB). La mémoire du moteur de suggestions (oublis récurrents) reste elle aussi sur l'appareil : les suggestions sont calculées localement, sans envoi à un serveur.",
  legal_privacy_s3_title: '3. Compte serveur (facultatif)',
  legal_privacy_s3_body:
    "Si vous créez un compte, nous traitons : votre email, votre nom d'affichage, votre mot de passe (haché avec argon2id, jamais stocké en clair) et les données de foyer que vous synchronisez.\n\nHébergement : serveurs et base de données chez Fly.io ; photos et fichiers chez Cloudflare R2 ; emails transactionnels (invitations, sécurité) envoyés via Resend. Ces prestataires agissent comme sous-traitants au sens du RGPD.",
  legal_privacy_s4_title: '4. Vos droits (RGPD)',
  legal_privacy_s4_body:
    "Vous disposez des droits d'accès, de rectification, d'effacement et de portabilité.\n\nDeux actions sont disponibles dès maintenant dans Réglages : « Exporter données » (fichier JSON complet) et « Supprimer compte » (efface toutes les données locales de l'appareil). Si un compte serveur est connecté, « Supprimer compte » efface aussi le compte serveur et les foyers dont vous êtes le seul membre.",
  legal_privacy_s5_title: '5. Sécurité et conservation',
  legal_privacy_s5_body:
    "Les échanges avec le serveur sont chiffrés (HTTPS) et l'authentification repose sur des cookies httpOnly avec protection CSRF. Les données serveur sont conservées tant que votre compte existe, puis supprimées. Aucune donnée n'est utilisée pour entraîner des modèles d'IA.",
  legal_privacy_s6_title: '6. Responsable et contact',
  legal_privacy_s6_body:
    "Pendant la phase alpha, le traitement est opéré par l'équipe Nestor. Pour exercer vos droits ou poser une question, utilisez le canal de contact communiqué lors de votre invitation au programme alpha.",
  legal_rules_s1_title: '1. Le programme alpha',
  legal_rules_s1_body:
    'Le programme alpha permet à un petit groupe de familles de tester Nestor avant sa sortie publique. La participation est gratuite, volontaire et sur invitation.',
  legal_rules_s2_title: '2. Ce que vous acceptez',
  legal_rules_s2_body:
    "Vous testez une version en construction : bugs, changements d'interface et interruptions de service font partie de l'expérience. Certaines fonctions (synchronisation, notifications) peuvent être activées ou désactivées sans préavis.",
  legal_rules_s3_title: "3. Vos données pendant l'alpha",
  legal_rules_s3_body:
    "Des remises à zéro peuvent être nécessaires entre deux versions. Nous vous préviendrons avant toute opération touchant les données serveur. Exportez régulièrement vos données (Réglages → Exporter données) : c'est votre meilleure sauvegarde.",
  legal_rules_s4_title: '4. Vos retours',
  legal_rules_s4_body:
    "Vos retours (bugs, idées, points de confusion) sont la raison d'être du programme. Partagez-les via le canal convenu lors de votre invitation. Dans un signalement de bug, n'incluez jamais d'information sensible concernant vos enfants.",
  legal_rules_s5_title: '5. Durée et sortie du programme',
  legal_rules_s5_body:
    "Le programme s'achèvera au lancement de la bêta publique. Vous pouvez le quitter à tout moment : exportez vos données puis supprimez-les depuis Réglages. Ce règlement peut être ajusté ; la version affichée dans l'application fait foi.",
} as const satisfies Record<string, string>;

/** Type de clé d'i18n — déduit du dictionnaire FR (source de vérité). */
export type TKey = keyof typeof fr;

/** Dictionnaire pour une langue donnée (sous-ensemble des clés FR). */
export type Dictionary = Partial<Record<TKey, string>>;
